import { createContext } from 'react';

const PageContext = createContext();

const PageProvider = (props) => {
    return <PageContext.Provider value={{}} {...props} />;
};

export { PageContext };
export default PageProvider;
